import { Player } from '@/service/lineups';

export function sortPlayersByShirtNumber(a: Player, b: Player) {
  return parseInt(a.shirtNumber) - parseInt(b.shirtNumber);
}
